
const VERSION = {
  SHA1:'c0474a5dc09e41b084299c2d34f7d886e00449c9',
  VERSION:2338,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
